'use client';

import { ContactInfo } from '../lib/types';

interface Step6Props {
  contact: ContactInfo;
  onChange: (contact: ContactInfo) => void;
  onNext: () => void;
  onBack: () => void;
}

const COUNTRIES = [
  '', 'Bénin', 'Togo', 'Côte d\'Ivoire', 'Sénégal', 'Burkina Faso',
  'Mali', 'Niger', 'Guinée', 'Cameroun', 'Gabon', 'Congo',
  'RD Congo', 'Madagascar', 'France', 'Belgique', 'Canada', 'Autre',
];

export default function Step6Contact({ contact, onChange, onNext, onBack }: Step6Props) {
  const canProceed =
    contact.fullName.trim().length >= 2 &&
    contact.email.includes('@') &&
    contact.phone.trim().length >= 8 &&
    contact.country.length > 0;

  return (
    <div className="animate-fade-in max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-2">Confirmez vos coordonnées</h2>
      <p className="text-muted mb-8">Vérifiez vos informations et complétez votre pays.</p>

      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium mb-1.5">
            Nom complet <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            value={contact.fullName}
            onChange={(e) => onChange({ ...contact, fullName: e.target.value })}
            placeholder="Ex: Jean Koffi"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1.5">
            Email personnel <span className="text-danger">*</span>
          </label>
          <input
            type="email"
            value={contact.email}
            onChange={(e) => onChange({ ...contact, email: e.target.value })}
            placeholder="Ex: jean@gmail.com"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1.5">
            Téléphone / WhatsApp <span className="text-danger">*</span>
          </label>
          <input
            type="tel"
            value={contact.phone}
            onChange={(e) => onChange({ ...contact, phone: e.target.value })}
            placeholder="Ex: +229 97 00 00 00"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1.5">
            Pays <span className="text-danger">*</span>
          </label>
          <select
            value={contact.country}
            onChange={(e) => onChange({ ...contact, country: e.target.value })}
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white"
          >
            {COUNTRIES.map((c) => (
              <option key={c} value={c}>
                {c || 'Sélectionnez votre pays...'}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex gap-3 mt-8">
        <button
          onClick={onBack}
          className="px-6 py-3 rounded-lg border border-border text-muted hover:bg-gray-50 transition-colors cursor-pointer"
        >
          Retour
        </button>
        <button
          onClick={onNext}
          disabled={!canProceed}
          className="flex-1 bg-primary hover:bg-primary-hover disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-lg transition-colors cursor-pointer"
        >
          Continuer
        </button>
      </div>
    </div>
  );
}